import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import promotypeService from "./promotypeService";

export const getPromotionals = createAsyncThunk(
  "promotype/all",
  async (thunkAPI) => {
    try {
      return await promotypeService.getPromotionalList();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const createPromotional = createAsyncThunk(
  "promotype/add",
  async (categoryData, thunkAPI) => {
    try {
      return await promotypeService.createPromotional(categoryData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateAPromotional = createAsyncThunk(
  "promotype/edit",
  async (category, thunkAPI) => {
    try {
      return await promotypeService.updatePromotionalList(category);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAPromotional = createAsyncThunk(
  "promotype/delete",
  async (id, thunkAPI) => {
    try {
      return await promotypeService.deletePromotionalList(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const getAPromotional = createAsyncThunk(
  "promotype/get",
  async (id, thunkAPI) => {
    try {
      return await promotypeService.getPromotional(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  promoLists: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const promotypeSlice = createSlice({
  name: "promoLists",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPromotionals.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPromotionals.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.promoLists = action.payload.result;
      })
      .addCase(getPromotionals.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createPromotional.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createPromotional.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdPromotional = action.payload;
      })
      .addCase(createPromotional.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateAPromotional.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAPromotional.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
       state.updatedPromotional = action.payload;
      })
      .addCase(updateAPromotional.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAPromotional.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAPromotional.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deleteAPromotional = action.payload.result;
      })
      .addCase(deleteAPromotional.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getAPromotional.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAPromotional.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.promotionalName = action.payload.result.promotype_name;
      })
      .addCase(getAPromotional.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default promotypeSlice.reducer;
